module.exports = __webpack_public_path__ + "img/photo-0062.971b79dd.jpg";